<template>
  <div id="app" class="app">
    <NoLayoutComponent v-if="noLayout"/>
    <Buy v-else-if="buy"/>
    <NotLogged v-else-if="notLogged"/>
    <layout v-else-if="!isAuth"/>
    <auth-layout v-else></auth-layout>
  </div>
</template>

<script>
  import Layout from 'components/layout/Layout'
  import AuthLayout from 'components/layout/AuthLayout'
  import VuesticPreLoader from 'vuestic-components/vuestic-preloader/VuesticPreLoader.vue'
  import NotLogged from './components/auth/NotLogged/NotLogged.vue'
  import Buy from './components/auth/purchase/buy.vue'
  import NoLayoutComponent from './components/layout/NoLayout.vue'
  import Vue from "vue";
  import { mapState, mapActions } from 'vuex';
  import store from './store'
  import {mapGetters} from 'vuex'

  export default {
    name: 'app',
    components: {
      VuesticPreLoader,
      AuthLayout,
      Layout,
      NotLogged,
      Buy,
      NoLayoutComponent
    },
    created () {
      // Query string params
      if (this.$route.query.region){
        localStorage.setItem('region', this.$route.query.region)
      }else {
        localStorage.setItem('region', 'BR')
      }

      if (this.$route.query.token){
        localStorage.setItem('token', this.$route.query.token)
      }

      // Set language
      const lang = this.$route.query.lang
      if(lang) {
        if(lang.split("-")[0] === 'pt'){
          Vue.i18n.set('br');
        } else {
          Vue.i18n.set('en');
        }
      }

      // Set no-layout 
      store.commit('setNoLayout', !!this.$route.query.nolayout)

      // Fetch client details
      this.fetchClientDetails()

      // Refresh Token
      // Commented out because was not working properly
      /*
      if (localStorage.getItem('X-refresh-token')  && localStorage.getItem('X-refresh-token') === true) {
        this.$axios.get('resfresktoken')
          .then(response => {
            if (response.data.WhmcsAuthUserRefresh.data.refresh != false) {
              localStorage.removeItem('token')
              localStorage.setItem('token', response.data.WhmcsAuthUserRefresh.data.refresh)
              this.$axios.defaults.headers['Authorization'] = 'Bearer ' + response.data.WhmcsAuthUserRefresh.data.refresh
            }
          })
          .catch(err => {
            console.log('error', err)
          })
          .finally(() => {
          });
      }
      */
    },
    methods: {
      ...mapActions('client', ['fetchClientDetails']),
    },
    computed:{
      ...mapGetters([
        'noLayout'
      ]),
      isAuth () {
        return this.$route.path.match('auth')
      },
      notLogged () {
        return this.$route.path.match('notlogged')
      },
      buy () {
        return this.$route.path.match('buy')
      },
      lang() {
        return Vue.i18n.locale()
      },
      ...mapState('client', ['clientDetails']),
    },
    watch: {
      lang(value) {
        // Updates Vee-validate language
        this.$validator.localize(value);
      }
    },
  }
</script>

<style lang="scss">
  @import "sass/main";

  body {
    height: 100%;
    #app {
      height: 100%;
    }
  }

  .loader {
    width: 48px;
    height: 48px;
    border: 3px solid #000;
    border-radius: 50%;
    display: inline-block;
    position: relative;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
  }
  .loader::after {
    content: '';
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top: 0;
    background: #b64afd;
    width: 16px;
    height: 16px;
    transform: translate(-50%, 50%);
    border-radius: 50%;
  }

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue